import clsx from 'clsx';
import Tooltip from 'components/layout/tooltip';
import { ReactNode } from 'react';
import { CoverageShortfall } from 'utils/coverage-shortfalls';

type CoverageShortfallTooltipProps = Readonly<{
  shortfalls: CoverageShortfall[];
  className?: string;
  children: ReactNode;
}>;

export default function CoverageShortfallTooltip({
  shortfalls,
  className,
  children
}: CoverageShortfallTooltipProps) {
  const hasShortfalls = shortfalls.length > 0;
  return (
    <div
      className={clsx('relative', hasShortfalls && 'cursor-help', className)}
    >
      {children}
      {hasShortfalls && (
        <Tooltip>
          <div className='flex flex-col gap-0.5 text-center'>
            {shortfalls.map((shortfall) => (
              <div key={shortfall.key}>{shortfall.text}</div>
            ))}
          </div>
        </Tooltip>
      )}
    </div>
  );
}
